export default __webpack_public_path__ + "static/media/abortion-protest.7338f404.png";